import React from 'react'
import { profileId } from '../../../shared/utils';

const no_challenge_tab = ({
  i18n, hasRewardLink, navigateToRewards, hasChallengeLink, rewardsAvailable,
  changeTabByIndex, title, msg,
}) => {

  const stageSelector = () => {
    if(rewardsAvailable) return 'reward'

    return 'achievements';
  };

  const navToAAchievements = () => window.location = '/achievements';
  const navToAEditProfile = () => window.location = `/profiles/${profileId}`;

  const profileAchievementsRewardsStage = {
    profile: {
      message: i18n('Why not complete your profile?'),
      iconClass: 'profile',
      btnText: i18n('Complete your profile'),
      link: navToAEditProfile,
    },
    achievements: {
      message: i18n('Take a look at your achievements!'),
      iconClass: 'achievement',
      btnText: i18n('View achievements'),
      link: navToAAchievements,
    },
    reward: {
      message: i18n(msg),
      iconClass: 'reward',
      btnText: i18n('Redeem a reward'),
      link: navigateToRewards,
    },
  };

  const stage = stageSelector();

  const { message, iconClass, btnText, link } = profileAchievementsRewardsStage[stage];
  const conditionalMessage = hasChallengeLink && hasRewardLink ? i18n(msg) : message;

  return (
    <div className="empty-area no-challenges">
        <p className="notification">{i18n(title)}</p>
        <div className="next-steps">
          <p>{conditionalMessage}</p>
          <div className="button-container">
            {hasRewardLink && (
              <button className="primary action" onClick={link}>
                  <i className={ `${iconClass} icon`}></i>
                  <span>{btnText}</span>
              </button>
            )}
            {hasChallengeLink && (
              <button className="primary action" onClick={() => changeTabByIndex(0)}>
                <i className="trophy icon"></i><span>{i18n('View challenges')}</span>
              </button>
            )}
          </div>
        </div>
    </div>
  )
};

no_challenge_tab.defaultProps = {
  hasRewardLink: false,
  hasChallengeLink: false,
  hasProfileLink: false,
};

export default no_challenge_tab;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/no_challenge_tab.jsx